import React from "react";
import DirectorMatches from "./DirectorMatches";
export const MatchManageHome_Page = { path: "/matches/manage", element: <DirectorMatches /> };
